const ALLOWED_TAGS = new Set([
  "a", "b", "blockquote", "br", "code", "div", "em", "h1", "h2", "h3", "h4",
  "h5", "h6", "hr", "i", "iframe", "img", "li", "ol", "p", "pre", "span", "strong",
  "table", "tbody", "td", "th", "thead", "tr", "u", "ul"
]);

const ALLOWED_ATTRS = new Set([
  "alt", "class", "colspan", "frameborder", "height", "href", "loading", "rel",
  "rowspan", "src", "style", "target", "title", "width"
]);

const URI_ATTRS = new Set(["href", "src"]);

function isSafeUrl(value) {
  const url = String(value || "").trim().replace(/[\u0000-\u001F\u007F\s]+/g, "");
  if (!url) return true;
  if (url.startsWith("/") || url.startsWith("#")) return true;
  return /^(https?:|mailto:|tel:|data:image\/(png|gif|jpeg|jpg|webp);base64,)/i.test(url);
}

function sanitizeStyle(value) {
  const style = String(value || "");
  if (/expression\s*\(|javascript\s*:|vbscript\s*:|data\s*:/i.test(style)) return "";
  return style;
}

export default function sanitizeHtml(html) {
  if (!html || typeof window === "undefined" || typeof document === "undefined") return html || "";

  const template = document.createElement("template");
  template.innerHTML = String(html);

  const walk = (node) => {
    if (node.nodeType === Node.COMMENT_NODE) {
      node.remove();
      return;
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      const tagName = node.tagName.toLowerCase();
      if (!ALLOWED_TAGS.has(tagName)) {
        if (["script", "style", "object", "embed"].includes(tagName)) {
          node.remove();
          return;
        }
        const children = Array.from(node.childNodes);
        children.forEach(walk);
        node.replaceWith(...children);
        return;
      }

      for (const attr of Array.from(node.attributes)) {
        const name = attr.name.toLowerCase();
        const value = attr.value;

        if (name.startsWith("on") || !ALLOWED_ATTRS.has(name)) {
          node.removeAttribute(attr.name);
          continue;
        }

        if (URI_ATTRS.has(name) && !isSafeUrl(value)) {
          node.removeAttribute(attr.name);
          continue;
        }

        if (name === "style") {
          const cleanStyle = sanitizeStyle(value);
          if (cleanStyle) node.setAttribute("style", cleanStyle);
          else node.removeAttribute(attr.name);
        }
      }

      if (tagName === "a") {
        node.setAttribute("rel", "noreferrer noopener");
      }
    }

    for (const child of Array.from(node.childNodes)) walk(child);
  };

  for (const child of Array.from(template.content.childNodes)) walk(child);
  return template.innerHTML;
}